import { TFunction } from 'i18next'
import { z } from 'zod'

export const createProfileFormSchema = (t: TFunction) =>
  z.object({
    firstName: z.string().min(1, {
      message: t('required'),
    }),
    lastName: z.string().min(1, {
        message: t('required'),
      }),
    phoneNumber: z.string().min(1, {
      message: t('required'),
    }),
    email: z
      .string()
      .email({ message: t('invalidEmail') })
      .min(5, {
        message: t('required'),
      }),
    position: z.string().min(1, {
      message: t('required'),
    }),
  })
